import { setDefaultLocale } from 'react-datepicker'
import ja from 'date-fns/locale/ja'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'react-datepicker/dist/react-datepicker.css'
import './src/asset/style/index.scss'
import 'leaflet/dist/leaflet.css'

setDefaultLocale(ja)

export { wrapPageElement, wrapRootElement } from './gatsby-ssr'

// CI/CD調査用